module.exports = __webpack_public_path__ + "img/bg4.a0186998.png";